import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';

const portfolioData = [
  {
    title: 'GreenPay Digital Wallet',
    subtitle: 'Super App Platform',
    href: '/portfolio/greenpay-wallet',
    src: '/images/greenpay-wallet-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'TOXO Rider App',
    subtitle: 'Taxi Passenger Mobile Application',
    href: '/portfolio/toxo-rider',
    src: '/images/toxo-rider-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'TOXO Driver App',
    subtitle: 'Taxi Driver Mobile Application',
    href: '/portfolio/toxo-driver',
    src: '/images/toxo-driver-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'Online Reservation Platform',
    subtitle: 'Service Businesses (Web & Mobile)',
    href: '/portfolio/reservation-platform',
    src: '/images/online-reservation-platform.png',
    category: 'web_design',
  },
  {
    title: 'Emiland App',
    subtitle: 'Fashion & Suit Ordering Mobile App',
    href: '/portfolio/emiland-app',
    src: '/images/emiland-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'GreenPay Chat',
    subtitle: 'Messaging & Communication App',
    href: '/portfolio/greenpay-chat',
    src: '/images/greenpay-chat-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'Raffe App',
    subtitle: 'Digital Raffles & Prize Campaigns',
    href: '/portfolio/raffe-app',
    src: '/images/raffe-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'Travel & Tour Booking',
    subtitle: 'Travel Booking Platform (Web)',
    href: '/portfolio/travel-booking',
    src: '/images/travel-tour-booking-platform.png',
    category: 'web_design',
  },
  {
    title: 'RahatBina',
    subtitle: 'Building & Hotel Management System',
    href: '/portfolio/rahatbina',
    src: '/images/rahatbina-building-management.jpg',
    category: 'web_design',
  },
  {
    title: 'Green Hotel App',
    subtitle: 'Hotel Booking Mobile Application',
    href: '/portfolio/green-hotel',
    src: '/images/green-hotel-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'Vegul App',
    subtitle: 'Bridal & Fashion E-commerce',
    href: '/portfolio/vegul-app',
    src: '/images/vegul-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'Cerene Website',
    subtitle: 'Fashion E-commerce Website',
    href: '/portfolio/cerene-website',
    src: '/images/cerene-website.png',
    category: 'web_design',
  },
  {
    title: 'CIAO Website',
    subtitle: 'Multilingual Education Platform',
    href: '/portfolio/ciao-website',
    src: '/images/ciao-website.png',
    category: 'web_design',
  },
  {
    title: 'PFL Platform',
    subtitle: 'Azerbaijan Professional Football League',
    href: '/portfolio/pfl-website',
    src: '/images/pfl-website.png',
    category: 'web_design',
  },
  {
    title: 'Emiland Website',
    subtitle: 'Luxury Menswear Brand Platform',
    href: '/portfolio/emiland-website',
    src: '/images/emiland-website.png',
    category: 'web_design',
  },
  {
    title: 'Superfon Website',
    subtitle: 'Mobile Accessories E-commerce',
    href: '/portfolio/superfon-website',
    src: '/images/superfon-website.png',
    category: 'web_design',
  },
  {
    title: 'B2B Loyalty App',
    subtitle: 'Wholesale Ordering & Bonus Management',
    href: '/portfolio/b2b-loyalty',
    src: '/images/b2b-loyalty-app.png',
    category: 'mobile_apps',
  },
  {
    title: 'ELFIM Auto Website',
    subtitle: 'Automotive Parts E-commerce',
    href: '/portfolio/elfim-auto',
    src: '/images/elfim-auto-website.png',
    category: 'web_design',
  },
  {
    title: 'KATech Terminal System',
    subtitle: 'Smart Self-Service Terminal Solution',
    href: '/portfolio/katech-terminal',
    src: '/images/katech-terminal-system.png',
    category: 'enterprise',
  },
];

const categoryMenu = [
  {
    title: 'Web Platforms',
    category: 'web_design',
  },
  {
    title: 'Mobile Apps',
    category: 'mobile_apps',
  },
  {
    title: 'Enterprise',
    category: 'enterprise',
  },
];

export default function PortfolioPage() {
  pageTitle('Portfolio');
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(9);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title="Portfolio"
        bgSrc="images/portfolio_hero_bg.jpeg"
        pageLinkText="Portfolio"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title="Selected Projects & Case Studies" subtitle="Our Portfolio" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li
                  className={active === item.category ? 'active' : ''}
                  key={index}
                >
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="row">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${
                index === 3 || index === 6 ? 'col-lg-8' : 'col-lg-4'
              } ${
                active === 'all'
                  ? ''
                  : !(active === item.category)
                  ? 'd-none'
                  : ''
              }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={item.href}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 6)}
              >
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      <Cta
        title="https://turderhoffnung.com"
        bgSrc="/images/cta_bg_2.jpeg"
        variant="rounded-0"
      />
    </>
  );
}
